<ng-container *ngIf="!showLoaderOverlay && !showNotFoundPage; else initialView">
  <div class="custom-container" *ngIf="!showUrlPinModal && !showRedirectLoader">
    <div class="header-container">
      <app-header></app-header>
    </div>
    <div class="main-content">
      <router-outlet />
    </div>
    <div class="footer-container">
      <app-footer></app-footer>
    </div>
  </div>
  <router-outlet *ngIf="showUrlPinModal" />
  <app-loader-overlay
    *ngIf="showRedirectLoader"
    [message]="'Redirecting...'"
  ></app-loader-overlay>
</ng-container>

<ng-template #initialView>
  <app-loader-overlay *ngIf="showLoaderOverlay"></app-loader-overlay>
  <app-page-not-found *ngIf="showNotFoundPage"></app-page-not-found>
</ng-template>

<app-pin-modal
  *ngIf="showUrlPinModal"
  [showPinModal]="showUrlPinModal"
  [pinError]="urlPinError"
  (close)="onUrlPinClose()"
  (submit)="onUrlPinSubmit($event)"
></app-pin-modal>
